import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const GoogleIcon: React.FC<SVGIconProps> = ({ size = 24, color, ...props }) => (
  <BaseSvg width={size} height={Math.round(size * (24 / 25))} viewBox="0 0 25 24" {...props}>
    <mask
      id="mask0_2310_28999"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <path d="M24.5 0H0.5V24H24.5V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_2310_28999)">
      <path
        d="M24.02 12.273C24.02 11.422 23.9437 10.6039 23.8018 9.81836H12.5V14.4602H18.9582C18.68 15.9602 17.8346 17.2311 16.5637 18.082V21.093H20.4418C22.7109 19.0039 24.02 15.9274 24.02 12.273Z"
        fill={color || '#4285F4'}
      />
      <path
        d="M12.4991 24.0003C15.7391 24.0003 18.4554 22.9257 20.4408 21.093L16.5626 18.0821C15.4882 18.8021 14.1136 19.2275 12.4991 19.2275C9.37355 19.2275 6.72815 17.1166 5.78447 14.2803H1.77539V17.3894C3.74999 21.3112 7.80815 24.0003 12.4991 24.0003Z"
        fill={color || '#34A853'}
      />
      <path
        d="M5.7854 14.2804C5.5454 13.5604 5.40908 12.7913 5.40908 12.0004C5.40908 11.2095 5.5454 10.4404 5.7854 9.72041V6.61133H1.77632C0.963679 8.23133 0.5 10.0641 0.5 12.0004C0.5 13.9367 0.963679 15.7695 1.77632 17.3895L5.7854 14.2804Z"
        fill={color || '#FBBC04'}
      />
      <path
        d="M12.4991 4.77276C14.2608 4.77276 15.8426 5.37816 17.0863 6.56724L20.5282 3.1254C18.45 1.18908 15.7336 0 12.4991 0C7.80815 0 3.74999 2.68908 1.77539 6.61092L5.78447 9.72C6.72815 6.88368 9.37355 4.77276 12.4991 4.77276Z"
        fill={color || '#E94235'}
      />
    </g>
  </BaseSvg>
);
